module.exports = __webpack_public_path__ + "img/auth.c5ff8d19.webp";